/**
 * Компонент для авторизации через Telegram
 * Использует библиотеку react-telegram-login
 */

import React, { useCallback } from 'react';
import TelegramLoginButton from 'react-telegram-login';
import config from '../config';

interface TelegramAuthProps {
  onSuccess?: (user: any) => void;
  onError?: (error: string) => void;
  onLinkAccount?: (telegramData: any) => void;
  className?: string;
  children?: React.ReactNode;
}

const TelegramAuth: React.FC<TelegramAuthProps> = ({ 
  onSuccess, 
  onError, 
  onLinkAccount,
  className = '',
  children 
}) => {
  const handleTelegramResponse = useCallback((response: any) => {
    console.log('Telegram auth response:', response);
    
    if (onSuccess) {
      onSuccess(response);
    }
  }, [onSuccess]);

  console.log('TelegramAuth render: config.telegramBotUsername =', config.telegramBotUsername);
  
  if (!config.telegramBotUsername) {
    console.log('TelegramAuth: returning null because no bot username');
    return null;
  }

  return (
    <div className={`telegram-auth ${className}`}>
      {children || (
        <div>
          <TelegramLoginButton
            botName={config.telegramBotUsername}
            dataOnauth={handleTelegramResponse}
            buttonSize="large"
            requestAccess="write"
            usePic={false}
            cornerRadius={20}
            lang="ru"
            additionalClasses="btn btn-outline-primary"
          />
        </div>
      )}
    </div>
  );
};

export default TelegramAuth;
